// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_w50","cls2":"FriendlySutdModal-cls2_47a FriendlySutdModal-cls1_w50"};